import { useCallback, useState } from "react";
import { captureError } from "@swiggy-private/core-ui";

export function useSessionStorage<T>(key: string, initialValue: T): [T, (v: T) => void] {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            if (typeof window === "undefined") {
                return initialValue;
            }

            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            captureError(error);
            return initialValue;
        }
    });

    const setValue = useCallback(
        (value: T): void => {
            try {
                if (typeof window === "undefined") {
                    return;
                }

                const valueToStore = value instanceof Function ? value(storedValue) : value;
                setStoredValue(valueToStore);
                window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
            } catch (error) {
                captureError(error);
            }
        },
        [key, storedValue],
    );

    return [storedValue, setValue];
}
